module.exports = __webpack_public_path__ + "static/media/file-word.505f4771.svg";